import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationModule } from '../i18n';
// import { AuthRoutingModule } from '../auth/auth-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng2FlatpickrModule } from 'ng2-flatpickr';
import { ClickToCopyComponent } from './dialogs/click-to-copy/click-to-copy.component';
import { ReasonListModalComponent } from '../survey/Reason-list/reason-list-modal/reason-list-modal.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { SortDirective } from 'src/app/directives/sort.directive';



@NgModule({
  declarations: [
    ClickToCopyComponent,
    ReasonListModalComponent,
    SortDirective
  ],
  imports: [
    CommonModule,
    TranslationModule,
    FormsModule,
    ReactiveFormsModule,
    Ng2FlatpickrModule,
    InlineSVGModule
  ],
  exports:[
    FormsModule,
    ReactiveFormsModule,
    Ng2FlatpickrModule,
    ClickToCopyComponent,
    InlineSVGModule,
    SortDirective
    ],
  providers:[
    ClickToCopyComponent
  ]
})
export class SharedModule { }
